import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { Box } from 'grid-styled';
// import { FormattedMessage } from "react-intl";
import BasePage from 'components/BasePage/BasePage';
import Content from 'components/BasePage/Content';
// import messages from "./messages";

@observer
export default class Profile extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }
  render() {
    return (
      <BasePage>
        <Content>
          <Box mb={'3vh'}>My profile page</Box>
        </Content>
      </BasePage>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/profile/Profile.js